const feedbackCodes = [
  { url: 'https://jola.louhin.com/go?nzxp43j4', code: '101' },
  { url: 'https://jola.louhin.com/go?8ngnm47z', code: '102' },
  { url: 'https://jola.louhin.com/go?3pgh29gr', code: '103' },
  { url: 'https://jola.louhin.com/go?b6dkk7jy', code: '104' },
  { url: 'https://jola.louhin.com/go?wnzdm3hs', code: '105' },
  { url: 'https://jola.louhin.com/go?5tn58y45', code: '106' },
  { url: 'https://jola.louhin.com/go?mbm9snyd', code: '107' },
  { url: 'https://jola.louhin.com/go?x6jztyzm', code: '108' },
  { url: 'https://jola.louhin.com/go?b42mzp78', code: '109' },
  { url: 'https://jola.louhin.com/go?wmfpz4y8', code: '110' },
  { url: 'https://jola.louhin.com/go?y56g44rt', code: '111' },
  { url: 'https://jola.louhin.com/go?43jdh96c', code: '112' },
  { url: 'https://jola.louhin.com/go?zs8k4rtd', code: '113' },
  { url: 'https://jola.louhin.com/go?jj2gpshh', code: '114' },
  { url: 'https://jola.louhin.com/go?prdtr3cy', code: '115' },
  { url: 'https://jola.louhin.com/go?fkgptwkc', code: '116' },
  { url: 'https://jola.louhin.com/go?cqrwz93c', code: '117' },
  { url: 'https://jola.louhin.com/go?585xst69', code: '118' },
  { url: 'https://jola.louhin.com/go?gx4sf4zm', code: '120' },
  { url: 'https://jola.louhin.com/go?72q7czt4', code: '122' },
  { url: 'https://jola.louhin.com/go?rgpgxgqb', code: '124' },
  { url: 'https://jola.louhin.com/go?s59h5mxm', code: '126' },
  { url: 'https://jola.louhin.com/go?g5bd8thq', code: '133' },
  { url: 'https://jola.louhin.com/go?cz4nrddf', code: '134' },
  { url: 'https://jola.louhin.com/go?x76sfdwr', code: '136' },
  { url: 'https://jola.louhin.com/go?s25w7nb4', code: '137' },
  { url: 'https://jola.louhin.com/go?r6wddyk8', code: '138' },
  { url: 'https://jola.louhin.com/go?yykkwk2y', code: '140' },
  { url: 'https://jola.louhin.com/go?htt4zczr', code: '142' },
  { url: 'https://jola.louhin.com/go?dccjqn4q', code: '144' },
  { url: 'https://jola.louhin.com/go?n7hss5cf', code: '146' },
  { url: 'https://jola.louhin.com/go?yx2drwzq', code: '148' },
  { url: 'https://jola.louhin.com/go?zsdyzmzk', code: '201' },
  { url: 'https://jola.louhin.com/go?94q2jg4j', code: '202' },
  { url: 'https://jola.louhin.com/go?t59dhcty', code: '203' },
  { url: 'https://jola.louhin.com/go?dt7q2nzh', code: '205' },
  { url: 'https://jola.louhin.com/go?gzff25kx', code: '206' },
  { url: 'https://jola.louhin.com/go?hy4kr3xx', code: '207' },
  { url: 'https://jola.louhin.com/go?5y3yfh6d', code: '208' },
  { url: 'https://jola.louhin.com/go?p6pj24hm', code: '209' },
  { url: 'https://jola.louhin.com/go?w5f6x9c7', code: '210' },
  { url: 'https://jola.louhin.com/go?yz25w7p4', code: '212' },
  { url: 'https://jola.louhin.com/go?bcxgknzf', code: '213' },
  { url: 'https://jola.louhin.com/go?2z47txf7', code: '214' },
  { url: 'https://jola.louhin.com/go?rwdg9yj4', code: '215' },
  { url: 'https://jola.louhin.com/go?zw7fys8f', code: '217' },
  { url: 'https://jola.louhin.com/go?n5pmw8yt', code: '218' },
  { url: 'https://jola.louhin.com/go?sk859c9t', code: '219' },
  { url: 'https://jola.louhin.com/go?95436rr9', code: '220' },
  { url: 'https://jola.louhin.com/go?dp9b726n', code: '221' },
  { url: 'https://jola.louhin.com/go?rwjwmssz', code: '222' },
  { url: 'https://jola.louhin.com/go?s9g9fdpg', code: '226' },
  { url: 'https://jola.louhin.com/go?82ynrkj9', code: '227' },
  { url: 'https://jola.louhin.com/go?83kydhmy', code: '228' },
  { url: 'https://jola.louhin.com/go?kwqskbfg', code: '229' },
  { url: 'https://jola.louhin.com/go?snj84p7w', code: '230' },
  { url: 'https://jola.louhin.com/go?85gp3jn6', code: '232' },
  { url: 'https://jola.louhin.com/go?jssmk39m', code: '233' },
  { url: 'https://jola.louhin.com/go?cnd39nth', code: '234' },
  { url: 'https://jola.louhin.com/go?bn4hqd38', code: '236' },
  { url: 'https://jola.louhin.com/go?354kpwhq', code: '238' },
  { url: 'https://jola.louhin.com/go?54z9tjcg', code: '239' },
  { url: 'https://jola.louhin.com/go?gj4dxjh8', code: '241' },
  { url: 'https://jola.louhin.com/go?6hh2gpnm', code: '242' },
  { url: 'https://jola.louhin.com/go?3qspm39h', code: '243' },
  { url: 'https://jola.louhin.com/go?m2rwq3cf', code: '244' },
  { url: 'https://jola.louhin.com/go?cp9pkxmk', code: '245' },
  { url: 'https://jola.louhin.com/go?mfpqmtyq', code: '246' },
  { url: 'https://jola.louhin.com/go?hnxf3396', code: '247' },
  { url: 'https://jola.louhin.com/go?gckdszh4', code: '248' },
  { url: 'https://jola.louhin.com/go?72wsqx6j', code: '249' },
  { url: 'https://jola.louhin.com/go?n5g398fg', code: '250' },
  { url: 'https://jola.louhin.com/go?kgyw26pc', code: '251' },
  { url: 'https://jola.louhin.com/go?zrqd7pp2', code: '252' },
  { url: 'https://jola.louhin.com/go?b7dcn8cm', code: '253' },
  { url: 'https://jola.louhin.com/go?j8dzwjk5', code: '255' },
  { url: 'https://jola.louhin.com/go?k86hbk5h', code: '256' },
  { url: 'https://jola.louhin.com/go?54phy3w6', code: '257' },
  { url: 'https://jola.louhin.com/go?59t6hqxq', code: '258' },
  { url: 'https://jola.louhin.com/go?3n4shhxj', code: '259' },
  { url: 'https://jola.louhin.com/go?nf6w2t2y', code: '260' },
  { url: 'https://jola.louhin.com/go?5mtbkx2b', code: '261' },
  { url: 'https://jola.louhin.com/go?4q6d3wzw', code: '262' },
  { url: 'https://jola.louhin.com/go?5qrs8qph', code: '264' },
  { url: 'https://jola.louhin.com/go?bjdtm4bh', code: '265' },
  { url: 'https://jola.louhin.com/go?k8gjg2tx', code: '266' },
  { url: 'https://jola.louhin.com/go?w4ztm3nd', code: '267' },
  { url: 'https://jola.louhin.com/go?hyb2rkbh', code: '268' },
  { url: 'https://jola.louhin.com/go?796fsd9n', code: '269' },
  { url: 'https://jola.louhin.com/go?c5n2ttnn', code: '270' },
  { url: 'https://jola.louhin.com/go?2k9pyfmk', code: '271' },
  { url: 'https://jola.louhin.com/go?9cmghncs', code: '272' },
  { url: 'https://jola.louhin.com/go?cpz52ws8', code: '273' },
  { url: 'https://jola.louhin.com/go?2xnh5rxq', code: '274' },
  { url: 'https://jola.louhin.com/go?2jms2ws9', code: '276' },
  { url: 'https://jola.louhin.com/go?r4s4hfcx', code: '280' },
  { url: 'https://jola.louhin.com/go?873wcddk', code: '282' },
  { url: 'https://jola.louhin.com/go?6scfcmf7', code: '284' },
  { url: 'https://jola.louhin.com/go?79w42d7f', code: '285' },
  { url: 'https://jola.louhin.com/go?fxh524pq', code: '291' },
  { url: 'https://jola.louhin.com/go?74fwdkx7', code: '293' },
  { url: 'https://jola.louhin.com/go?4bbw88zp', code: '295' },
  { url: 'https://jola.louhin.com/go?kqcphkmx', code: '297' },
  { url: 'https://jola.louhin.com/go?8qfkh6w8', code: '299' },
  { url: 'https://jola.louhin.com/go?gr5m5ryh', code: '301' },
  { url: 'https://jola.louhin.com/go?zc7ybw87', code: '302' },
  { url: 'https://jola.louhin.com/go?qgk2w75h', code: '303' },
  { url: 'https://jola.louhin.com/go?8tjmtrmx', code: '305' },
  { url: 'https://jola.louhin.com/go?krssqks7', code: '306' },
  { url: 'https://jola.louhin.com/go?33f5fgrf', code: '307' },
  { url: 'https://jola.louhin.com/go?c789hcfn', code: '308' },
  { url: 'https://jola.louhin.com/go?g6xzjytk', code: '309' },
  { url: 'https://jola.louhin.com/go?tjdcy8th', code: '310' },
  { url: 'https://jola.louhin.com/go?2xy57kcw', code: '312' },
  { url: 'https://jola.louhin.com/go?bycchhc9', code: '313' },
  { url: 'https://jola.louhin.com/go?m6n37w7g', code: '314' },
  { url: 'https://jola.louhin.com/go?k4wtbbgm', code: '316' },
  { url: 'https://jola.louhin.com/go?7z9chnbt', code: '318' },
  { url: 'https://jola.louhin.com/go?m9hcpxpt', code: '320' },
  { url: 'https://jola.louhin.com/go?22trwbqc', code: '326' },
  { url: 'https://jola.louhin.com/go?wy3p3yxf', code: '327' },
  { url: 'https://jola.louhin.com/go?z2f6kcdj', code: '328' },
  { url: 'https://jola.louhin.com/go?gsw9mzfb', code: '329' },
  { url: 'https://jola.louhin.com/go?g7jxskqz', code: '330' },
  { url: 'https://jola.louhin.com/go?cm89qrkg', code: '331' },
  { url: 'https://jola.louhin.com/go?r2mf3jdk', code: '332' },
  { url: 'https://jola.louhin.com/go?nyyzk4d3', code: '333' },
  { url: 'https://jola.louhin.com/go?g7kdn52n', code: '334' },
  { url: 'https://jola.louhin.com/go?s829yxm3', code: '336' },
  { url: 'https://jola.louhin.com/go?jkb9kywd', code: '401' },
  { url: 'https://jola.louhin.com/go?343q9z49', code: '402' },
  { url: 'https://jola.louhin.com/go?qqqn89p8', code: '403' },
  { url: 'https://jola.louhin.com/go?4cyp7x9f', code: '404' },
  { url: 'https://jola.louhin.com/go?mmqt2drg', code: '405' },
  { url: 'https://jola.louhin.com/go?c65t3t38', code: '406' },
  { url: 'https://jola.louhin.com/go?kph4rf28', code: '408' },
  { url: 'https://jola.louhin.com/go?d34ms75q', code: '410' },
  { url: 'https://jola.louhin.com/go?8mbbsjy9', code: '412' },
  { url: 'https://jola.louhin.com/go?83h3khbq', code: '414' },
  { url: 'https://jola.louhin.com/go?c4863yfy', code: '416' },
  { url: 'https://jola.louhin.com/go?6gqmt2cn', code: '420' },
  { url: 'https://jola.louhin.com/go?ztnfmhqs', code: '421' },
  { url: 'https://jola.louhin.com/go?q6x4bgpf', code: '424' },
  { url: 'https://jola.louhin.com/go?sx9w83n2', code: '425' },
  { url: 'https://jola.louhin.com/go?4xn5dn6n', code: '430' },
  { url: 'https://jola.louhin.com/go?s5fn494m', code: '431' },
  { url: 'https://jola.louhin.com/go?w5r98pcb', code: '432' },
  { url: 'https://jola.louhin.com/go?2ss99pkd', code: '433' },
  { url: 'https://jola.louhin.com/go?9z33zwrj', code: '434' },
  { url: 'https://jola.louhin.com/go?j4f9yt6w', code: '435' },
  { url: 'https://jola.louhin.com/go?sgwbdf8f', code: '436' },
  { url: 'https://jola.louhin.com/go?8gf785d8', code: '437' },
  { url: 'https://jola.louhin.com/go?2jwrb2wg', code: '438' },
  { url: 'https://jola.louhin.com/go?cxhg4j7r', code: '439' },
  { url: 'https://jola.louhin.com/go?8xb5ffbh', code: '440' },
  { url: 'https://jola.louhin.com/go?wg7djy9k', code: '441' },
  { url: 'https://jola.louhin.com/go?wzqbpqy5', code: '442' },
  { url: 'https://jola.louhin.com/go?s5f935hz', code: '443' },
  { url: 'https://jola.louhin.com/go?xbg6fy7x', code: '445' },
  { url: 'https://jola.louhin.com/go?gnznk7yg', code: '451' },
  { url: 'https://jola.louhin.com/go?s6p7fbxw', code: '452' },
  { url: 'https://jola.louhin.com/go?wptcwn3h', code: '453' },
  { url: 'https://jola.louhin.com/go?hqds4zn4', code: '454' },
  { url: 'https://jola.louhin.com/go?6bqrq73r', code: '455' },
  { url: 'https://jola.louhin.com/go?y9c64jq3', code: '601' },
  { url: 'https://jola.louhin.com/go?k8cjwrtj', code: '602' },
  { url: 'https://jola.louhin.com/go?bfszrms2', code: '603' },
  { url: 'https://jola.louhin.com/go?g4shwx2r', code: '604' },
  { url: 'https://jola.louhin.com/go?66dszjrc', code: '605' },
  { url: 'https://jola.louhin.com/go?75jkkhyx', code: '606' },
  { url: 'https://jola.louhin.com/go?m5prsgkp', code: '608' },
  { url: 'https://jola.louhin.com/go?z6smbhf4', code: '609' },
  { url: 'https://jola.louhin.com/go?74m6nb5w', code: '610' },
  { url: 'https://jola.louhin.com/go?kb5psb96', code: '611' },
  { url: 'https://jola.louhin.com/go?tmjnx33t', code: '612' },
  { url: 'https://jola.louhin.com/go?t3c5p9qm', code: '614' },
  { url: 'https://jola.louhin.com/go?4prrwbxd', code: '617' },
  { url: 'https://jola.louhin.com/go?2ypmk7nf', code: '618' },
  { url: 'https://jola.louhin.com/go?dfxpybjr', code: '620' },
  { url: 'https://jola.louhin.com/go?zkrgfh4b', code: '631' },
  { url: 'https://jola.louhin.com/go?9x4938fp', code: '632' },
  { url: 'https://jola.louhin.com/go?8ksgzkpt', code: '633' },
  { url: 'https://jola.louhin.com/go?29n6m3g4', code: '634' },
  { url: 'https://jola.louhin.com/go?4my6c569', code: '635' },
  { url: 'https://jola.louhin.com/go?x3r6yf4x', code: '636' },
  { url: 'https://jola.louhin.com/go?862cd96y', code: '637' },
  { url: 'https://jola.louhin.com/go?txgnk5d4', code: '638' },
  { url: 'https://jola.louhin.com/go?n2dcqqy7', code: '639' },
  { url: 'https://jola.louhin.com/go?yrdjdkx3', code: '640' },
  { url: 'https://jola.louhin.com/go?2pfsb7nb', code: '641' },
  { url: 'https://jola.louhin.com/go?56wnmjdp', code: '651' },
  { url: 'https://jola.louhin.com/go?6hhcb5zf', code: '652' },
  { url: 'https://jola.louhin.com/go?m3kc7t32', code: '653' },
  { url: 'https://jola.louhin.com/go?433rk2xr', code: '654' },
  { url: 'https://jola.louhin.com/go?qzbkzgs8', code: '655' },
  { url: 'https://jola.louhin.com/go?f48sss62', code: '656' },
  { url: 'https://jola.louhin.com/go?52fjn69d', code: '657' },
  { url: 'https://jola.louhin.com/go?pnk9r9m8', code: '658' },
  { url: 'https://jola.louhin.com/go?4mpmdptj', code: '659' },
  { url: 'https://jola.louhin.com/go?w74nx4ht', code: '660' },
  { url: 'https://jola.louhin.com/go?529mmbpp', code: '661' },
  { url: 'https://jola.louhin.com/go?wbhgr8yn', code: '662' },
  { url: 'https://jola.louhin.com/go?bcsdzn2h', code: '663' },
  { url: 'https://jola.louhin.com/go?pj952pkn', code: '701' },
  { url: 'https://jola.louhin.com/go?wmnbnh2z', code: '702' },
  { url: 'https://jola.louhin.com/go?n4ydcr7d', code: '703' },
  { url: 'https://jola.louhin.com/go?642c5h6n', code: '705' },
  { url: 'https://jola.louhin.com/go?ym8pqms6', code: '707' },
  { url: 'https://jola.louhin.com/go?2f3m9768', code: '708' },
  { url: 'https://jola.louhin.com/go?d9jtyd6q', code: '709' },
  { url: 'https://jola.louhin.com/go?444ngh3x', code: '801' },
  { url: 'https://jola.louhin.com/go?gthsbwh3', code: '802' },
  { url: 'https://jola.louhin.com/go?j7gm5q9y', code: '803' },
  { url: 'https://jola.louhin.com/go?236dqr9f', code: '804' },
  { url: 'https://jola.louhin.com/go?q65kfgx5', code: '805' },
  { url: 'https://jola.louhin.com/go?w38m84n9', code: '807' },
  { url: 'https://jola.louhin.com/go?jk28s7cy', code: '809' },
  { url: 'https://jola.louhin.com/go?4yk3tdh9', code: '811' },
  { url: 'https://jola.louhin.com/go?6y9tscry', code: '813' },
  { url: 'https://jola.louhin.com/go?brgpzq22', code: '815' },
  { url: 'https://jola.louhin.com/go?5ct66zmn', code: '820' },
  { url: 'https://jola.louhin.com/go?gwmnnj75', code: '821' },
  { url: 'https://jola.louhin.com/go?w6yxb36y', code: '822' },
  { url: 'https://jola.louhin.com/go?g8kwxh5w', code: '823' },
  { url: 'https://jola.louhin.com/go?k5yrcp6p', code: '824' },
  { url: 'https://jola.louhin.com/go?fdm686ss', code: '825' },
  { url: 'https://jola.louhin.com/go?mqgwkwqz', code: '1012' },
  { url: 'https://jola.louhin.com/go?j5xdbzdq', code: '1015' },
  { url: 'https://jola.louhin.com/go?w5f2cqgz', code: '1016' },
  { url: 'https://jola.louhin.com/go?xg66tjwc', code: '1167' },
  { url: 'https://jola.louhin.com/go?j9rh6tp3', code: '1168' },
  { url: 'https://jola.louhin.com/go?pkr9cgpj', code: '1169' },
  { url: 'https://jola.louhin.com/go?9mm5cn4d', code: '1170' },
  { url: 'https://jola.louhin.com/go?z3dmqwmb', code: '1172' },
  { url: 'https://jola.louhin.com/go?rws5trbr', code: '1174' },
  { url: 'https://jola.louhin.com/go?df2wsq7h', code: '1984' },
  { url: 'https://jola.louhin.com/go?bhdt98zb', code: '1985' },
  { url: 'https://jola.louhin.com/go?tdbd3kxg', code: '1987' },
  { url: 'https://jola.louhin.com/go?tzzrprn4', code: '1988' },
  { url: 'https://jola.louhin.com/go?y9sgwr7y', code: '2005' },
  { url: 'https://jola.louhin.com/go?4thkwmwj', code: '2006' },
  { url: 'https://jola.louhin.com/go?fc29pkh2', code: '2007' },
  { url: 'https://jola.louhin.com/go?mcxt2mts', code: '2008' },
  { url: 'https://jola.louhin.com/go?mn343xdj', code: '2010' },
  { url: 'https://jola.louhin.com/go?z9x8tdgt', code: '2011' },
  { url: 'https://jola.louhin.com/go?qqs629qh', code: '2012' },
  { url: 'https://jola.louhin.com/go?6qhmstkk', code: '2013' },
  { url: 'https://jola.louhin.com/go?3ccpt6t8', code: '2015' },
  { url: 'https://jola.louhin.com/go?wy8bq8w9', code: '2061' },
  { url: 'https://jola.louhin.com/go?f5schpd3', code: '2108' },
  { url: 'https://jola.louhin.com/go?jdjjn5qh', code: '2505' },
];

export default feedbackCodes;

export function getFeedbackUrl(shortId) {
  const stopNumber = shortId.replace(/H\s?0?/, '');
  if (feedbackCodes.some(({ code }) => code === stopNumber)) {
    return `hsl.fi/fixit/${stopNumber}`;
  }
  return null;
}
